module.exports = __webpack_public_path__ + "static/media/south-africa-flag.cb03bcab.jpg";